import React from "react";
import styled, { keyframes } from "styled-components";

const pulseAnimation = keyframes`
  0% {
   opacity: 1
  }

  50% {
    opacity: 0.5
  }

  100% {
    opacity: 1
  }
`;

const SVG = styled.svg`
  animation: ${pulseAnimation} 1.25s infinite;
  fill: var(--fd-colors-content-loading-default, rgba(10, 10, 10, 0.05));
`;

const Container = styled.div`
  background-color: var(--fd-colors-background-surface);
`;

const TabsLoading = () => (
  <Container>
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="49"
      viewBox="0 0 375 49"
      fill="none"
      preserveAspectRatio="none"
    >
      <mask id="path-1-inside-1_104_67655" fill="white">
        <path d="M0 0H375V49H0V0Z" />
      </mask>
      <path d="M0 0H375V49H0V0Z" fill="white" />
      <path
        d="M375 48H0V50H375V48Z"
        fill="#C6D3E1"
        mask="url(#path-1-inside-1_104_67655)"
      />
      <rect
        x="12"
        y="16"
        width="55.3721"
        height="16"
        rx="2"
        fill="var(--fd-colors-content-loading-default, rgba(10, 10, 10, 0.05))"
      />
      <rect
        x="85.9072"
        y="16"
        width="55.3721"
        height="16"
        rx="2"
        fill="var(--fd-colors-content-loading-default, rgba(10, 10, 10, 0.05))"
      />
      <rect
        x="159.814"
        y="16"
        width="55.3721"
        height="16"
        rx="2"
        fill="var(--fd-colors-content-loading-default, rgba(10, 10, 10, 0.05))"
      />
      <rect
        x="233.721"
        y="16"
        width="55.3721"
        height="16"
        rx="2"
        fill="var(--fd-colors-content-loading-default, rgba(10, 10, 10, 0.05))"
      />
      <rect
        x="307.628"
        y="16"
        width="55.3721"
        height="16"
        rx="2"
        fill="var(--fd-colors-content-loading-default, rgba(10, 10, 10, 0.05))"
      />
    </SVG>
  </Container>
);

export default TabsLoading;
